import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import VisitorCounter from './VisitorCounter';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/portal');
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
        </div>

        <div className="footer-links">
          <h4>{t('footer.quickLinks')}</h4>
          <ul>
            <li><Link to="/">{t('nav.home')}</Link></li>
            <li><Link to="/projects">{t('nav.projects')}</Link></li>
            <li><Link to="/about">{t('nav.about')}</Link></li>
            <li><Link to="/contact">{t('nav.contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>{t('footer.resources')}</h4>
          <ul>
            <li><a href="https://github.com/BenBand" target="_blank" rel="noopener noreferrer">GitHub</a></li>
            <li><a href="https://www.linkedin.com/in/bernard-banda-6995b633b/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          </ul>
        </div>

        <div className="footer-social">
          <h4>{t('footer.connect')}</h4>
          <div className="social-links">
            <a href="https://github.com/BenBand" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/bernard-banda-6995b633b/" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {currentYear} Computer Science Student Portfolio. {t('footer.rights')}
        </p>
      </div>
      {!isAdminRoute && <VisitorCounter />}
    </footer>
  );
};

export default Footer;
